import { render, staticRenderFns } from "./TheNavbarMenuOntologyTab.vue?vue&type=template&id=23cabf38&"
import script from "./TheNavbarMenuOntologyTab.vue?vue&type=script&setup=true&lang=ts&"
export * from "./TheNavbarMenuOntologyTab.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports